export default __webpack_public_path__ + "static/media/3.e5abb42f.svg";